import { useMemo } from "react";

import { useListAvailableTechnicalInstructions } from "@api/rest/types-and-hooks";
import { PromptKeyedLookupSelect } from "@pages/Prompts/PromptKeyedLookupSelect";

interface PromptTechnicalInstructionsSelectProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

/** Technical-instructions picker — pipelines'
 *  ``prompts/technical_instructions/*.yaml`` catalog with a custom
 *  fallback allowed (pipelines' ``_resolved_technical_instructions`` uses
 *  the raw string when the key doesn't match — see
 *  ``build_prompts_registry.py``). */
export const PromptTechnicalInstructionsSelect: React.FC<PromptTechnicalInstructionsSelectProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { data, isLoading } = useListAvailableTechnicalInstructions();
  const items = useMemo(() => (data?.status === 200 ? data.data.items : []), [data]);
  return (
    <PromptKeyedLookupSelect
      value={value}
      onChange={onChange}
      items={items}
      isLoading={isLoading}
      disabled={disabled}
      allowCustom
    />
  );
};
